export const token_validate = `query token_validate{
    token_validate{
        need_password_update
        expiry
        language
        terms_of_use{
            id
            document
            document_en
        }
    }
}`;
